import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import styled, { css } from "styled-components";
import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5";
import { Direction, DirectionHelper } from "../../../shared/resources/DirectionHelper";
import { CharacterAnimationPrefixIdle } from "../../canvas/game/character/characterAnimationHelper";
import { CharacterEditorColorButton } from "../game/ui components/GameUIElements";
const Container = styled.div.withConfig({
  displayName: "ComponentTurnCharacter__Container",
  componentId: "sc-o93xkj-0"
})(["display:flex;flex-grow:1;justify-content:center;align-items:center;"]);
const BasicButton = css(["margin:4px;height:40px;width:100px;border-radius:10px;background-color:", ";color:black;cursor:pointer;"], CharacterEditorColorButton);
const TurnCounterClockwiseButton = styled(IoReturnDownForward).withConfig({
  displayName: "ComponentTurnCharacter__TurnCounterClockwiseButton",
  componentId: "sc-o93xkj-1"
})(["", ";"], BasicButton);
const TurnClockwiseButton = styled(IoReturnDownBack).withConfig({
  displayName: "ComponentTurnCharacter__TurnClockwiseButton",
  componentId: "sc-o93xkj-2"
})(["", ";"], BasicButton);
export const ComponentTurnCharacter = observer(props => {
  const [currentDirection, setCurrentDirection] = useState(Direction.East);

  function onDirectionChange(direction) {
    setCurrentDirection(direction);
    props.onAnimationStateChange(CharacterAnimationPrefixIdle + DirectionHelper.getName(direction));
  }

  function onClickTurnCounterClockwise() {
    onDirectionChange(DirectionHelper.turnCounterClockwise(currentDirection));
  }

  function onClickTurnClockwise() {
    onDirectionChange(DirectionHelper.turnClockwise(currentDirection));
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TurnCounterClockwiseButton, {
    onClick: onClickTurnCounterClockwise
  }), /*#__PURE__*/React.createElement(TurnClockwiseButton, {
    onClick: onClickTurnClockwise
  }));
});